<template>
  <Layout>
    <template #head>
      <Basics :basics="resume.basics" />
    </template>
    <template #main>
      <Work :work="resume.work" />
      <Projects :projects="resume.projects" />
      <Volunteer :volunteer="resume.volunteer" />
      <Skills
        :skills="resume.skills"
        :categorized-skills="resume.categorizedSkills"
      />
      <Education :education="resume.education" />
      <Languages :languages="resume.languages" />
      <Awards :awards="resume.awards" />
      <Certificates :certificates="resume.certificates" />
      <Publications :publications="resume.publications" />
      <Interests :interests="resume.interests" />
      <Additional :additional="resume.additional" />
      <References :references="resume.references" />
    </template>
  </Layout>
</template>

<script lang="ts">
import { defineComponent, provide } from 'vue'
import resume from '@/schemas/json_resume.json'
import Basics from '../../components/Basics.vue'
import Work from '../../components/Work.vue'
import Education from '../../components/Education.vue'
import Skills from '../../components/Skills.vue'
import Projects from '../../components/Projects.vue'
import References from '../../components/References.vue'
import Volunteer from '../../components/Volunteer.vue'
import Awards from '../../components/Awards.vue'
import Certificates from '../../components/Certificates.vue'
import Publications from '../../components/Publications.vue'
import Languages from '../../components/Languages.vue'
import Interests from '../../components/Interests.vue'
import Layout from './Layout.vue'
import Additional from '../../components/Additional.vue'

export default defineComponent({
  name: 'ResumeBasic',
  components: {
    Basics,
    Work,
    Education,
    Skills,
    Projects,
    References,
    Volunteer,
    Awards,
    Certificates,
    Publications,
    Languages,
    Interests,
    Additional,
    Layout,
  },
  props: {
    resume: {
      type: Object,
      required: true,
      default: () => resume,
    },
  },
})
</script>
